import Vue from 'vue';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css';
import 'vuetify/src/styles/main.sass'
import i18n from "@/i18n";

Vue.use(Vuetify);

/**
 * Top Drivers Colors:
 *
 * - yellow:  #43b02a
 * - black:   #000000
 */

export default new Vuetify({
	lang: {
		t: (key, ...params) => i18n.t(key, params).toString(),
	},
	theme: {
		dark: false,
		themes: {
			light: {
				primary: '#43b02a',
				secondary: '#000000',
				accent: '#43b02a',
				error: '#FF5252',
				info: '#2196F3',
				success: '#43b02a',
				warning: '#f7941e',

				'topdrivers-green': '#43b02a',
				'topdrivers-black': '#000000',
			},
		}
	},
});
